import {Box, Dialog, DialogTitle, IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function CommonModal(props) {
    return (
        <Dialog
            fullWidth={true}
            open={props.open}
            onClose={() => props.handleDialogClose()}>
            <div id="common-modal-dialog">
                <DialogTitle>
                    <Box display="flex" alignItems="center">
                        <Box
                            id="common-modal-dialog-title"
                            flexGrow={1}>
                            {props.title}
                        </Box>
                        <Box>
                            <IconButton onClick={() => props.handleDialogClose()}>
                                <CloseIcon/>
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>

                {props.content === undefined ? props.children : props.content}
            </div>
        </Dialog>
    )
}